import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

const createSuggestionsListTemplate = () => {
  return (
    `<ul class="suggestions-list">
    </ul>`
  );
};

export default class SuggestionsList extends Abstract {
  constructor() {
    super();
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  _getTemplate() {
    return createSuggestionsListTemplate();
  }
}
